import type { TStoreName } from "../types/domain/store";
import { buildDocument } from "./build-document";
import { APP_NAME, STORE_SUFFIX } from "./store";

/** 스토어별로 다른 쿼리만 키로 두고, 나머지는 default 에 `${S}` 보간으로 한 벌만 유지한다. */
const withFragments = (operations: Partial<Record<TStoreName, string>> & { default: string }) =>
  buildDocument(operations[APP_NAME] ?? operations.default);

const S = STORE_SUFFIX;

export const predictiveSearchQuery = withFragments({
  default: `#graphql
    query PredictiveSearch${S}($query: String!, $limit: Int, $limitScope: PredictiveSearchLimitScope, $searchableFields: [SearchableField!], $types: [PredictiveSearchType!], $unavailableProducts: SearchUnavailableProductsType) {
      predictiveSearch(query: $query, limit: $limit, limitScope: $limitScope, searchableFields: $searchableFields, types: $types, unavailableProducts: $unavailableProducts) {
        products { ...PredictiveSearchProductFields${S} }
        queries { text }
      }
    }
  `,
});

/** 검색 결과 */
export const searchQuery = withFragments({
  default: `#graphql
    query Search${S}($query: String!, $first: Int, $productFilters: [ProductFilter!], $sortKey: SearchSortKeys, $reverse: Boolean, $types: [SearchType!], $prefix: SearchPrefixQueryType, $after: String) {
      search(query: $query, first: $first, productFilters: $productFilters, sortKey: $sortKey, reverse: $reverse, types: $types, prefix: $prefix, after: $after) {
        totalCount
        productFilters { ...FilterFields }
        pageInfo { ...PageInfoFields }
        edges {
          node {
            ... on Product { ...CommonCollectionProductFields${S} }
          }
        }
      }
    }
  `,
});
